import { Demo } from './demo';
import React from 'react';

export function DemoResolver() {
    // Check for additional permissions or any logic before rendering a page

    return <Demo />;
}
